export default __webpack_public_path__ + "static/nati-714377768d0b958e162732429030af82.png";